define('Transaction.Line.Views.Option.View.GiftWrap', [

], function TransactionLineViewsOptionViewGiftWrap(

) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var layoutComponent = container.getComponent('Layout');

            layoutComponent.addToViewContextDefinition('Transaction.Line.Views.Option.View', 'isSelected', 'boolean', function isSelected(context) {
                return context.selectedValue.internalid === 'T';
            });
        }
    };
});

